import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';

interface ThirdPartyDataH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
}
@inject('app', 'site', 'user')
@observer
class ThirdPartyDataH5Page extends BasePage<ThirdPartyDataH5PageProps> {
    componentDidMount() {
        super.componentDidMount();
        const { site } = this.props;
        if (site) {
            site.setShowHeader(false);
            site.setAppDownloadShowStatus(false); 
        }
    }

    // 立即下载
    downloadClick = (id: string | number) => {
        // this.props.history && this.props.history.push(`/topic/${id}`);
    };


    render() {
        return (<div className={styles.wrapper}>
            <div className={styles.box}>
                <h1 className={styles.title}>个人信息第三方共享清单</h1>
                <h2 className={styles.title2}>微信分享SDK</h2>
                <p>‌第三方公司名称‌：深圳市腾讯计算机系统有限公司</p>
                <p>‌共享类型‌：内嵌SDK</p>
                <p>共享信息‌：内容信息（分享或收藏内容详情）</p>
                <p>‌使用目的‌：帮助用户分享内容至微信或添加微信收藏</p>
                <p>‌使用场景‌：在调起微信进行分享或收藏内容时使用</p>
                <p>‌共享方式‌：SDK本机采集</p>
                <p>第三方个人信息处理规则：</p>
                <p>
                    <a
                        href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8
                    </a>
                </p>
                <p>&nbsp;</p>
                <h2 className={styles.title2}>Bugly SDK</h2>
                <p>第三方公司名称：深圳市腾讯计算机系统有限公司</p>
                <p>使用目的及功能场景：排查质量问题,帮助APP提升运行质量</p>
                <p>处理的个人信息类型：手机型号、手机品牌、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID</p>
                <p>第三方SDK隐私政策链接：</p>
                <p>
                    <a
                        href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56
                    </a>
                </p>
                <p>第三方SDK官网链接：
                    <a
                        href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
                        target="_blank"
                        rel="noopener noreferrer"
                    >https://bugly.qq.com/v2/</a>
                </p>
                <p>处理方式：通过去标识化、加密传输和处理的安全处理方式</p>
            </div>
        </div>)
    }
}

export default withRouter(ThirdPartyDataH5Page);
